<div
  *ngIf="error"
  class="backdrop"
  style="
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  "
></div>

<div
  *ngIf="error"
  class="content-div"
  style="
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 468px;
    height: 360px;
    background-color: white;
    z-index: 1010;
    border-radius: 4px;
    border: 1px solid white;
  "
>
  <div class="text-center" style="margin-top: 9%">
    <img src="/assets/images/paraphrasing tool/alert.svg" />

    <div style="width: 440px; height: 64px; margin-left: 16px">
      <p
        class="error mt-4"
        style="font-size: 24px; font-weight: 500; line-height: 33.89px"
      >
        {{ errorAlerts }}
      </p>
    </div>

    <button class="mt-4 butn-alert" (click)="closeErrorDiv()">Ok</button>
  </div>
</div>

<div
  *ngIf="success"
  class="backdrop"
  style="
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  "
></div>

<div
  *ngIf="success"
  class="content-div"
  style="
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 468px;
    height: 360px;
    background-color: white;
    z-index: 1010;
    border-radius: 4px;
    border: 1px solid white;
  "
>
  <div class="text-center" style="margin-top: 9%">
    <img
      src="/assets/images/paraphrasing tool/success.svg"
      style="width: 138px; height: 138px"
    />

    <p
      *ngIf="success"
      class="error mt-4"
      style="font-size: 24px; font-weight: 500; line-height: 33.89px"
    >
      {{ successAlert }}
    </p>
  </div>
</div>
